import {
  fetchBscFinancialGoals,
  fetchBscCustomerValueGoals,
  fetchBscStrategicGoalGoals,
  fetchBscStrategicIssueGoals,
  fetchBscHumanCapitalGoalGoals,
  fetchBscInfoCapitalGoalAppGoals,
  fetchBscInfoCapitalGoalDataGoals,
  fetchBscInfoCapitalGoalItGoals,
  fetchBscOrgCapitalGoalGoals,
  fetchFinancialGoals,
  fetchCustomerValues,
  fetchStrategicGoals,
  fetchStrategicIssues,
  fetchHumanCapitalGoals,
  fetchInfoCapitalGoalsApp,
  fetchInfoCapitalGoalsData,
  fetchInfoCapitalGoalsIt,
  fetchOrgCapitalGoals,
} from "../../../api/companyApi";

/**
 * BSC カテゴリごとの設定
 * fetchGoals(businessUnitId)        → GET でゴール一覧を取得
 * fetchSuccessFactors(domainId)     → 目標新規作成時にSuccessFactorドロップダウンを取得
 * titleKey                          → 一覧ページのタイトル i18n キー
 */
export const BSC_CATEGORY_CONFIG = {
  "financial-goals": {
    fetchGoals: fetchBscFinancialGoals,
    fetchSuccessFactors: fetchFinancialGoals,
    titleKey: "bsc.financialGoals.title",
  },
  "customer-values": {
    fetchGoals: fetchBscCustomerValueGoals,
    fetchSuccessFactors: fetchCustomerValues,
    titleKey: "bsc.customerValues.title",
  },
  "strategic-goals": {
    fetchGoals: fetchBscStrategicGoalGoals,
    fetchSuccessFactors: fetchStrategicGoals,
    titleKey: "bsc.strategicGoals.title",
  },
  "strategic-issues": {
    fetchGoals: fetchBscStrategicIssueGoals,
    fetchSuccessFactors: fetchStrategicIssues,
    titleKey: "bsc.strategicIssues.title",
  },
  "human-capital-goals": {
    fetchGoals: fetchBscHumanCapitalGoalGoals,
    fetchSuccessFactors: fetchHumanCapitalGoals,
    titleKey: "bsc.humanCapitalGoals.title",
  },
  "info-capital-goals-app": {
    fetchGoals: fetchBscInfoCapitalGoalAppGoals,
    fetchSuccessFactors: fetchInfoCapitalGoalsApp,
    titleKey: "bsc.infoCapitalGoalsApp.title",
  },
  "info-capital-goals-data": {
    fetchGoals: fetchBscInfoCapitalGoalDataGoals,
    fetchSuccessFactors: fetchInfoCapitalGoalsData,
    titleKey: "bsc.infoCapitalGoalsData.title",
  },
  "info-capital-goals-it": {
    fetchGoals: fetchBscInfoCapitalGoalItGoals,
    fetchSuccessFactors: fetchInfoCapitalGoalsIt,
    titleKey: "bsc.infoCapitalGoalsIt.title",
  },
  "org-capital-goals": {
    fetchGoals: fetchBscOrgCapitalGoalGoals,
    fetchSuccessFactors: fetchOrgCapitalGoals,
    titleKey: "bsc.orgCapitalGoals.title",
  },
};
